export default __webpack_public_path__ + "assets/audio/ssml/say-as.0bdb14038ef15640295f7751f38c0a7d.mp3";